import { memo } from "react";

export const ZodError = memo(({ message }: { message: string | undefined }) => {
	return <p className='text-sm text-red-600'>{message}</p>;
});
